import {filter, map, sortBy, uniq} from 'lodash';

import Fact from 'components/shared/fact';
import FileLink from 'pages/Guideline/FileLink';

export default function PublicationFileList({files}) {
  const years = uniq(map(files, (f) => f.year));

  const latestYear = sortBy(years).reverse()[0];

  const pubs = filter(files, (p) => p.type === 'PUBLICATION' && p.year === latestYear);
  const sups = filter(files, (p) => p.type === 'SUPPLEMENT' && p.year === latestYear);

  return (
    <div>
      <Fact label={`${latestYear} Guideline`}>
        {map(pubs, (p) => <FileLink key={p.url} label="Publication" {...p} />)}
        {map(sups, (p) => <FileLink key={p.url} label="Supplement" {...p} />)}
      </Fact>
    </div>
  );
}
